export default __webpack_public_path__ + "static/media/tree1.00233f0d.png";